<template>
  <v-bottom-navigation app
    :value="bottom_navigation_value"
  >
    <LocaleChanger v-if="$route.name === 'Simulation'"/>

    <!-- MOBILE NAV ON SITE -->
    <div
      v-else-if="getUseOnSite"
      class="bottom-nav-on-site-container"
    >
      <!-- PROJECTS -->
      <button
        class="bottom-nav-on-site-button"
        :style="`background-color: ${cached_route == 'ProjectOverView' ? highlight : transp};`"
        v-ripple
        @click="cached_route = 'ProjectOverView', navigateToRoute('ProjectOverView')"
      >
        <TIcon name="construction" />
        <TText value="Projects" small font_weight="400" />
      </button>

      <!-- QR CODES -->
      <button
        class="bottom-nav-on-site-button"
        :style="`background-color: ${cached_route == 'ScanQRCodeOnSite' ? highlight : transp};`"
        v-ripple
        @click="cached_route = 'ScanQRCodeOnSite', navigateToRoute('ScanQRCodeOnSite')"
      >
        <TIcon name="qr-code" />
        <TText value="Scan" small font_weight="400" />
      </button>

      <!-- MY WORKPACKAGES -->
      <button
        v-if="false"
        class="bottom-nav-on-site-button"
        :style="`background-color: ${cached_route == 'UserHome' ? highlight : transp};`"
        v-ripple
        @click="cached_route = 'UserHome', navigateToRoute('UserHome')"
      >
        <!-- TODO: add appropriate route -->
        <TIcon name="takt-plan-workpackage" />
        <TText value="Packages" small font_weight="400" />
      </button>

      <!-- ACCOUNT -->
      <button
        class="bottom-nav-on-site-button"
        :style="`background-color: ${cached_route.includes('Account') ? highlight : transp};`"
        v-ripple
        @click="cached_route = 'Account', navigateToRoute('Account')"
      >
        <TIcon name="person-small" />
        <TText value="Account" small font_weight="400" />
      </button>
    </div>

    <!-- MOBILE NAV -->
    <div v-else>
      <v-btn
        value="UserHome"
        @click="$router.push({
          name: 'UserHome'
          })"
        >
        <span>{{$t('AppLayout.NavBar.Home')}}</span>
        <v-icon>home</v-icon>
      </v-btn>

      <v-btn
        value="ProjectOverView"
        @click="$router.push({
          name: 'ProjectOverView'
          })"
        >
        <span>{{$t('AppLayout.NavBar.Projects')}}</span>
        <v-icon>domain</v-icon>
      </v-btn>

      <v-btn
        value="WorkBench"
        @click="$router.push({
          name: 'WorkBench'
          })"
        >
        <span>{{$t('AppLayout.NavBar.Workbench')}}</span>
        <svg-icon
          class="mr-1"
          name="takt_workbench"
          :size="25"
        />
      </v-btn>

      <v-btn
        value="Account"
        @click="$router.push({
          name: 'Account'
          })"
        >
        <span>{{$t('AppLayout.NavBar.Account')}}</span>
        <v-icon>person</v-icon>
      </v-btn>
    </div>
  </v-bottom-navigation>
</template>

<script>
import { mapGetters } from 'vuex';
import LocaleChanger from '@/components/LocaleChanger.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';

export default {
  components: {
    LocaleChanger,
    TText,
    TIcon,
  },

  data: () => ({
    cached_route: '',
    highlight: 'rgba(255, 255, 255, 0.05)',
    transp: 'rgba(255, 255, 255, 0)',
  }),

  beforeUpdate() {
    this.cached_route = this.$route.name;
  },

  computed: {
    ...mapGetters('View',[
      'getUseOnSite'
    ]),
    bottom_navigation_value(){
      if (this.$route.matched[0]) {
        if (this.$route.matched[0].name === 'Project') {
          return 'ProjectOverView';
        } else {
          return this.$route.matched[0].name;
        }
      }
      return false;
    }
  },

  methods: {
    navigateToRoute(route) {
      if(this.$route.name != route) {
        this.$router.push({
          name: route
        });
      }
    },
  },
}
</script>
<style>
.bottom-nav-on-site-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 4 */
  width: 100%;
}
.bottom-nav-on-site-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 8px;
}
</style>
